import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { WRITE_MESSAGE_BUTTON_TEXT } from '../../../../constants/requestForm/buttonText';
import { MODERATION_FINAL_STEP } from './moderationFinal';
export var MODERATION_ISSUES_STEP = {
  code: EStepCodes.ModerationIssues,
  question: {
    code: EQuestionCodes.ModerationIssues,
    title: 'Уведомления от модерации',
    fields: [],
    validation: [],
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: WRITE_MESSAGE_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: MODERATION_FINAL_STEP.code
  }]
};